import * as React from "react";

import type { DesignaliProps } from "../../types";

export const LinkedIn = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <rect
          strokeWidth={0}
          fill="#ffffff"
          x="2.96"
          y="3.11"
          width="18.09"
          height="17.79"
        />
        <path
          strokeWidth={0}
          fill="#2867b2"
          d="M12,2.01c2.84,0,5.68,0,8.52,0,.76,0,1.37.54,1.47,1.2.01.07.02.15.02.22v17.14c0,.76-.6,1.38-1.36,1.42-.05,0-.1,0-.15,0H3.5c-.71,0-1.25-.38-1.44-1.03-.04-.14-.06-.28-.06-.42,0-5.69,0-11.39,0-17.08,0-.81.61-1.44,1.42-1.45.69,0,1.37,0,2.06,0h6.51ZM12.67,10.79c0-.4,0-.74,0-1.08,0-.17-.04-.23-.22-.22-.82,0-1.63.01-2.45,0-.19,0-.24.06-.24.25,0,3.04,0,6.07,0,9.11,0,.19.05.25.24.25.85,0,1.7,0,2.54,0,.19,0,.24-.05.24-.25,0-1.53,0-3.06,0-4.58,0-.32.02-.64.08-.95.12-.65.41-1.17,1.1-1.34.21-.05.44-.06.67-.06.69,0,1.14.34,1.3,1.01.09.39.12.8.13,1.2.01,1.57,0,3.14,0,4.71,0,.18.05.25.24.25.85,0,1.7,0,2.54,0,.18,0,.23-.06.23-.24,0-1.69,0-3.38,0-5.07,0-.69-.03-1.38-.19-2.06-.22-.92-.64-1.71-1.55-2.12-.9-.4-1.85-.48-2.81-.23-.79.21-1.39.69-1.85,1.42h0ZM7.95,14.27c0-1.52,0-3.04,0-4.56,0-.17-.05-.22-.22-.22-.86,0-1.72,0-2.58,0-.17,0-.22.04-.22.22,0,3.05,0,6.11,0,9.16,0,.18.07.22.23.22.85,0,1.7,0,2.54,0q.25,0,.25-.25v-4.56h0ZM6.44,8.2c.96,0,1.73-.77,1.73-1.73s-.77-1.74-1.74-1.74-1.73.77-1.73,1.75c0,.96.77,1.72,1.74,1.72h0Z"
        />
      </svg>
    );
  },
);

export default LinkedIn;
